import { setCookie } from 'tiny-cookie';

export interface AccessToken {
  token: string;
  refreshToken: string;
  expiresIn: number;
}

function jwtCookieName(): string {
  return window.__JWT_COOKIE_NAME__ || 'jwt';
}

function refreshTokenCookieName(): string {
  return window.__REFRESH_TOKEN_COOKIE_NAME__ || 'refresh_token';
}

export function setAuthCookies(accessToken: AccessToken): void {
  const cookieOptions = {
    expires: `${accessToken.expiresIn}s`,
  };

  setCookie(jwtCookieName(), accessToken.token, cookieOptions);
  setCookie(refreshTokenCookieName(), accessToken.refreshToken);
}

export function redirectToDashboard(): void {
  window.location.href = '/dashboard/#/home';
}
